import { Box, Container, Typography } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const footerLinks = [
  { path: '/', labelKey: 'footer.home' },
  { path: '/releases', labelKey: 'footer.whatsNew' },
  { path: '/releases/emoji-17', labelKey: 'footer.emoji17' },
  { path: '/support', labelKey: 'footer.emojiGuides' },
  { path: '/support/windows', labelKey: 'footer.windows' },
  { path: '/support/macos', labelKey: 'footer.macos' },
  { path: '/support/linux', labelKey: 'footer.linux' },
];

export const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const langParam = new URLSearchParams(location.search).get('lang');
  const buildHref = (path: string) => (langParam ? `${path}?lang=${langParam}` : path);

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, path: string) => {
    e.preventDefault();
    navigate(path);
  };

  return (
    <Box
      component="footer"
      sx={{
        borderTop: '1px solid',
        borderColor: 'divider',
        mt: 4,
        py: 3,
      }}
    >
      <Container maxWidth="xl">
        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: { xs: 1, sm: 2 },
            justifyContent: 'center',
          }}
        >
          {footerLinks.map((link) => (
            <Typography key={link.path} component="span" variant="body2" color="text.secondary">
              <a
                href={buildHref(link.path)}
                onClick={(e) => handleClick(e, buildHref(link.path))}
                style={{ color: 'inherit', textDecoration: 'none' }}
              >
                {t(link.labelKey)}
              </a>
            </Typography>
          ))}
        </Box>
        <Typography
          variant="caption"
          color="text.disabled"
          sx={{ display: 'block', textAlign: 'center', mt: 2 }}
        >
          {t('footer.tagline')}
        </Typography>
      </Container>
    </Box>
  );
};
